import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const location = new ModelTableView([
	...Object.values(C)
]);

location.visibleProperties([ "name", "geo", "address", "phone", "email" ]);
location.sortBy("name");

export default location;



// WEBPACK FOOTER //
// ./src/services/components/views/location.js